// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:768px){.bloglist>div:nth-child(odd) .preview-container[data-v-79813418]:before{width:95%}.bloglist>div:nth-child(2n) .preview-container[data-v-79813418]:before{width:95%;margin-left:5%}}.bloglist>div[data-v-79813418]:nth-child(n+1){margin-top:10%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
